import { styled } from '@mui/material';

export const PageW = styled('div')`
  width: 100%;
  padding-left: 38px;
  padding-top: 64px;
  position: relative;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    padding: 88px 16px 96px 16px;
  }
`;
